import Vue from 'vue'
import Vuex from 'vuex'
import entry from './modules/entry'
import axios from 'axios'
import jQuery from 'jquery'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    kenList: [],
    schoolList: [],
    schoolFounderList: [
      { code: '', name: 'お選びください' },
      { code: 1, name: '国立' },
      { code: 2, name: '公立' },
      { code: 5, name: '私立' }
    ],
    paymentList: [
      { code: 'bill', id: 1, name: '払込票によるお支払い' },
      { code: 'ecol', id: 0, name: '代金引換によるお受け取り' },
      { code: 'shop', id: 2, name: 'オンラインショップで購入' }
    ],
    subjectList: [],
    gradeList: [],
    forceEntry: 0,
    showTestButton: (process.env.VUE_APP_SHOW_TEST_BTN == 'yes')
  },
  getters: {
    isAgreed() { return true },
    kenList(state) { return state.kenList },
    paymentList(state) { return state.paymentList },
    schoolFounderList(state) { return  state.schoolFounderList },
    schoolList(state) { return state.schoolList },
    subjectList(state) {return state.subjectList },
    gradeList(state) { return state.gradeList },
    isForceEntryMode(state) { return state.forceEntry == 1 }
  },
  mutations: {
    initKenList(state) {
      axios.get(process.env.VUE_APP_BASE_URL + "api/kencode.asp")
        .then(res => {
          state.kenList = [{ code: '', name: 'お選びください' }].concat(res.data)
        })
        .catch(e => {
          window.console.warn('error', e)
        })
    },
    initSubjectList(state) {
      axios.get(process.env.VUE_APP_BASE_URL + "api/subjects.json")
        .then(res => {
          state.subjectList = [{ code: '', name: 'お選びください' }].concat(res.data)
        })
        .catch(e => {
          window.console.warn('error', e)
        })
    },
    initGradeList(state) {
      axios.get(process.env.VUE_APP_BASE_URL + "api/grades.json")
        .then(res => {
          state.gradeList = [{ code: '', name: 'お選びください' }].concat(res.data)
        })
        .catch(e => {
          window.console.warn('error', e)
        })
    },
    refreshSchoolList(state) {
      var xml2list = function(xml) {
        return jQuery(xml).find("school").map(function() {
          var code = jQuery(this).find("tkscd").text()
          var name = jQuery(this).find("nnm").text()
          return {code: code, name: name}
        }).get()
      }

      let ken = state.entry.ken
      let founder = state.entry.schoolFounder
      if (ken == '' || founder == '') return [];

      const params = {
        kenno: ken,
        secchino: founder
      }
      var list = [{code: '', name: 'お選びください'}]
      axios.get(process.env.VUE_APP_BASE_URL + "api/optscname.asp", { params })
      .then(res => {
        // console.log(res)
        state.schoolList = list.concat(xml2list(res.data))
        state.entry.schoolCode = '' // reset schoolCode
      })
      .catch(e => {
        state.schoolList = list
        state.entry.schoolCode = '' // reset schoolCode
        window.console.warn('error', e)
      })
    },
    setForceEntryMode(state) {
      state.forceEntry = 1
    }
  },
  actions: {
    initialize({ commit }) {
      commit("initKenList")
      commit("initSubjectList")
      commit("initGradeList")
      commit("entry/loadStorageEntry")
    },
    refreshSchoolList({ commit }) {
      commit("refreshSchoolList")
    },
    setForceEntryMode({ commit }) {
      commit("setForceEntryMode")
    }
  },
  modules: {
    entry
  }
})
